import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {HomeComponent} from './components/home/home.component';
import {ChangelogComponent} from './components/changelog/changelog.component';
import {LoginComponent} from './components/login/login.component';
import {AuthGuard} from './core/auth/auth.guard';
import {PermissionGuard} from './core/permissions/permission.guard';
import { MainComponent } from './components/main/main.component';


const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: '', component: MainComponent, canActivate: [AuthGuard], children: [
      { path: '', component: HomeComponent, canActivate: [AuthGuard], data: { breadcrumb: 'MENU.MAIN.HOME' } },
      { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
      { path: 'dziennik-zmian', component: ChangelogComponent, canActivate: [AuthGuard], data: { breadcrumb: 'MENU.MAIN.CHANGELOG' } },
      {
        path: 'urlopy',
        loadChildren: () =>
          import('./features/leaves/leaves.module').then(m => m.LeavesModule), canActivate: [AuthGuard, PermissionGuard], data: { breadcrumb: 'MENU.MAIN.HOLIDAYS', permissionKey: 'leaves' }
      },
      {
        path: 'produkty',
        loadChildren: () => import('./features/products/products.module').then(m => m.ProductsModule),
        canActivate: [AuthGuard],
        data: { breadcrumb: 'MENU.PRODUCTS.PRODUCTS' },
      },
      {
        path: 'shipping',
        loadChildren: () => import('./features/shipping/shipping.module').then(m => m.ShippingModule),
        canActivate: [AuthGuard],
        data: { breadcrumb: 'MENU.PRODUCTS.DELIVERIES' },
      },
      {
        path: 'profile',
        loadChildren: () => import('./features/profiles/profiles.module').then(m => m.ProfilesModule),
        canActivate: [AuthGuard, PermissionGuard],
        data: { breadcrumb: 'MENU.ADMIN.PROFILES', permissionKey: 'admin.profiles' },
      },
      {
        path: 'ustawienia',
        loadChildren: () => import('./features/settings/settings.module').then(m => m.SettingsModule),
        canActivate: [AuthGuard, PermissionGuard],
        data: { breadcrumb: 'MENU.ADMIN.SETTINGS', permissionKey: 'admin.settings' },
      },
      {
        path: 'eksporty',
        loadChildren: () => import('./features/exports/exports.module').then(m => m.ExportsModule),
        canActivate: [AuthGuard],
        data: { breadcrumb: 'MENU.DOCUMENTS.EXPORTS' },
      },
      {
        path: 'zestawienia',
        loadChildren: () =>
          import('./features/invoice-reports/invoice-reports.module').then(m => m.InvoiceReportsModule),
        canActivate: [AuthGuard],
        data: { breadcrumb: 'MENU.DOCUMENTS.REPORTS' },
      },
      {
        // Dostep pilnuje backend (biala lista w statistics.controller);
        // menu tylko chowa link przed nieuprawnionymi.
        path: 'statystyki',
        loadChildren: () =>
          import('./features/statistics/statistics.module').then(m => m.StatisticsModule),
        canActivate: [AuthGuard],
        data: { breadcrumb: 'MENU.MAIN.STATISTICS' },
      },
      {
        path: 'wholesaler',
        loadChildren: () => import('./features/wholesalers/wholesalers.module').then(m => m.WholesalersModule),
        canActivate: [AuthGuard],
        data: { breadcrumb: 'MENU.CLIENTS.WHOLESALERS' },
      },
      {
        path: 'deposits',
        loadChildren: () =>
          import('./features/deposits/deposits.module').then(m => m.DepositsModule), canActivate: [AuthGuard], data: { breadcrumb: 'MENU.CLIENTS.DEPOSITS' }
      },
      {
        path: 'product-price-lists',
        loadChildren: () => import('./features/product-price-lists/product-price-lists.module').then(m => m.ProductPriceListsModule),
        canActivate: [AuthGuard],
        data: { breadcrumb: 'MENU.PRODUCTS.PRICE_LISTS' },
      },
      {
        path: 'orders',
        loadChildren: () => import('./features/orders/orders.module').then(m => m.OrdersModule),
        canActivate: [AuthGuard],
        data: { breadcrumb: 'MENU.DOCUMENTS.ORDERS' },
      },
      {
        path: 'stock-requests',
        loadChildren: () => import('./features/stock-requests/stock-requests.module').then(m => m.StockRequestsModule),
        canActivate: [AuthGuard],
        data: { breadcrumb: 'MENU.DOCUMENTS.STOCK_REQUESTS' },
      },
      {
        path: 'faktury-kosztowe',
        loadChildren: () => import('./features/cost-invoices/cost-invoices.module').then(m => m.CostInvoicesModule),
        canActivate: [AuthGuard],
        data: { breadcrumb: 'MENU.DOCUMENTS.COST_INVOICES' },
      },
      {
        path: 'numery-seryjne',
        loadChildren: () => import('./features/serial-numbers/serial-numbers.module').then(m => m.SerialNumbersModule),
        canActivate: [AuthGuard],
        data: { breadcrumb: 'MENU.DOCUMENTS.SERIAL_NUMBERS' },
      },
      {
        path: 'szukaj-po-trackingu',
        loadChildren: () => import('./features/tracking-search/tracking-search.module').then(m => m.TrackingSearchModule),
        canActivate: [AuthGuard],
        data: { breadcrumb: 'MENU.DOCUMENTS.TRACKING_SEARCH' },
      },
      {
        path: 'invoices',
        loadChildren: () => import('./features/invoices/invoices.module').then(m => m.InvoicesModule),
        canActivate: [AuthGuard],
        data: { breadcrumb: 'MENU.DOCUMENTS.INVOICES' },
      },
      {
        path: 'magazyn-marketingowy',
        loadChildren: () => import('./features/marketing/marketing.module').then(m => m.MarketingModule),
        canActivate: [AuthGuard],
        data: { breadcrumb: 'MENU.MAIN.MARKETING_WAREHOUSE' },
      },
      {
        path: 'sklepy-i-kanaly',
        loadChildren: () => import('./features/channels/channels.module').then(m => m.ChannelsModule),
        canActivate: [AuthGuard],
        data: { breadcrumb: 'MENU.MAIN.CHANNELS' },
      },
      {
        path: 'local-services',
        loadChildren: () => import('./features/local-services/local-services.module').then(m => m.LocalServicesModule),
        canActivate: [AuthGuard],
        data: { breadcrumb: 'MENU.MAIN.LOCAL_SERVICES' },
      },
    ]},
  { path: '**', redirectTo: '/login'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
